import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Paper from "@material-ui/core/Paper";
import Draggable from "react-draggable";
import { useStyles } from "./LeaveWorkConfirmationDialogStyles";
import { useTranslation } from "react-i18next";

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

export default function LeaveWorkConfirmationDialog({ open, handleConf }) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={() => handleConf(false)}
      PaperComponent={PaperComponent}
    >
      <DialogTitle
        style={{ cursor: "move" }}
        className={classes.root}
        id="draggable-dialog-title"
      >
        {t("LEAVE_WORK_CONFIRMATION_DIALOG_TITLE")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText style={{ wordBreak: "break-word" }}>
          {t("LEAVE_WORK_CONFIRMATION_DIALOG_BODY")}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => handleConf(true)}
          color="primary"
          style={{ fontWeight: "bold" }}
        >
          {t("YES")}
        </Button>
        <Button onClick={() => handleConf(false)} color="primary">
          {t("FORM_CANCEL")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
